/*
----- Stock Indicator ----- 
- This handles what happens when you click a SOH indicator.
  - Does it create a callout? 
  - Does it pop a modal that prompts for details?
*/


function initialiseAll() {
    $.each($(expressSelectors()['stock-indicators']['initialise']), function() {
        // Get context.
        let context = $(this);
        // Initialise.
        initalise(context);
    });
}

var instances = {};

function setInstance(context) {
    let id = context.attr(expressSelectors()['stock-indicators']['initialise']);
    // If this tooltip has not been initialise then create new instance.
    if (!id) {
        id = generateId();
        // Assign id.
        context.attr('stock-indicator-id', id);
        // Create a new instance.
        instances[id] = {};
    }
    return id;
}

function getInstance(context) {
    return context.attr(expressSelectors()['stock-indicators']['instance']);
}

function setContext(id, context) {
    instances[id]['context'] = context;
    return instances[id]['context'];
}

function getContext(id) {
    return instances[id]['context'];
}

function setPrompt(id, value) {
    instances[id]['has-prompt'] = value;
    return instances[id]['has-prompt'];
}

function getPrompt(id) {
    return instances[id]['has-prompt'];
}

function initalise(context) {
    // Set instance id.
    let id = setInstance(context);
    // Determine whether we need to prompt the user to additional details.
    let isPrompt = (context.attr('data-modal-form') != undefined);
    // Add prompt status to instance config.
    setPrompt(id, isPrompt);
    // Assign context to instance.
    setContext(id, context);

    // If we do not requre to prompt for more information then ajax the server.
    if (!isPrompt) {
        context.on('click', function(event) {
            // Prevent default behavour.
            event.preventDefault();
            // Button context.
            let button = $(this);
            // Check is anchor is disabld.
            let isDisabled = button.hasClass('disabled');
            if (isDisabled) {
                return false;
            }
            // Get url.
            let url = AXISAjax.postUrl(button);
            // Post to server.
            AXISAjax.post(url, "", "html", button).then((data) => {
                // Get response.
                let response = data['data'];
                // $('body').append(response);
                context.append(response);
            }).catch((error) => {
                AXISDebug.output(3, error);
            });
        });
    }
}

function updateNotification(context) {
    // Get the reference.
    let reference = context.attr(expressSelectors()['stock-indicators']['update']);
    // Get content.
    let content = context.html();
    // Remove context as it is no longer needed.
    context.remove();
    // Update tooltip.
    return notificationActive(reference, content);
}

function notificationActive(refernece, tooltipContent) {
    if (!refernece) {
        AXISDebug.output(3,"Stock Indicators: no refernence supplied so cannot toggle active state.");
        return false;
    }

    // Find the stock indicator(s) that matches the reference.
    let context = $('.stock-indicator').find('[reference=' + refernece + ']');
    // Get their container
    let container = context.parents('.stock-indicator');

    context = context.parents('.stock-indicator');
    // Add active class.
    container.addClass('active');
    // Remove modal so the user doesn't get prompted for info, as the server now knows the user's details.
    $.each(instances, function(key, value) {
        value.context.removeAttr('data-modal-form');
    });
    // Destroy instances.
    destroyAll();
    // Re-initialise.
    initialiseAll();
    // Update tooltip.
    if (tooltipContent) {
        // Find the tooltip context that needs to be update.
        let tooltip = container.find(expressSelectors()['tooltip']['initialise']);
        // Get tooltip instance to update.
        let id = AXISTooltip.getInstance(tooltip);
        // Update tooltip.
        let update = AXISTooltip.updateContent(id, tooltipContent);    
    }
    // Disable modal trigger.
    // context.find(".stock-indicator-button").addClass('disabled');
    // Add animation.
    container.find('.stock-notification-icon').addClass('animated swing');
    // Make sure class has been applied.
    if (container.hasClass('active')) {
        return context;
    } else {
        AXISDebug.output(3,"Stock Indicators: failed to add active state.");
        return false;
    }
}

function destroyAll() {
    $.each(instances, function(key, value) {
        destroy(value.context);
    });
}

function destroy(context) {
    // Remove listener.
    context.off('click');
    // Remove Id.
    context.removeAttr(expressSelectors()['stock-indicators']['instance']);
}

var stockIndicators = $.stockIndictors = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initalise(context);
    },
    notificiationActive: (refernece, tooltipContent) => {
        return notificationActive(refernece, tooltipContent);
    },
    update: (context) => {
        return updateNotification(context);
    }
}

export { stockIndicators };